import { GetFn, IntegrationSlice, SetFn } from '../../types/zustandTypes';

export const createIntegrationsSlice = (
  set: SetFn,
  get: GetFn
): IntegrationSlice => ({
  integrationsSoftwareArray: [],
  integrationsApi: {}
});
